
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from 'apps/prompt-builder-FE/src/environments/environment';
import { Template } from 'apps/prompt-builder-FE/src/core/interface/template.interface';
import { GenericResponse } from '@core/interface';

@Injectable({
  providedIn: 'root'
})
export class RemoteTemplateService {
  private apiUrl = `${environment.apiUrl}/api/templates`;

  constructor(private http: HttpClient) { }

  getAll(): Observable<GenericResponse<Template[]>> {
    return this.http.get<GenericResponse<Template[]>>(this.apiUrl);
  }

  getById(id: string): Observable<GenericResponse<Template>> {
    return this.http.get<GenericResponse<Template>>(`${this.apiUrl}/${id}`);
  }

  create(template: Partial<Template>): Observable<GenericResponse<Template>> {
    return this.http.post<GenericResponse<Template>>(this.apiUrl, template);
  }

  update(id: string, template: Partial<Template>): Observable<GenericResponse<Template>> {
    return this.http.put<GenericResponse<Template>>(`${this.apiUrl}/${id}`, template);
  }

  delete(id: string): Observable<GenericResponse<void>> {
    return this.http.delete<GenericResponse<void>>(`${this.apiUrl}/${id}`);
  }

  duplicate(id: string): Observable<GenericResponse<Template>> {
    return this.http.post<GenericResponse<Template>>(`${this.apiUrl}/${id}/duplicate`, {});
  }

  getPublicTemplates(page: number, limit: number): Observable<GenericResponse<{ templates: Template[], total: number }>> {
    return this.http.get<GenericResponse<{ templates: Template[], total: number }>>(`${this.apiUrl}/public?page=${page}&limit=${limit}`);
  }

  searchPublicTemplates(query: string, page: number, limit: number): Observable<GenericResponse<{ templates: Template[], total: number }>> {
    return this.http.get<GenericResponse<{ templates: Template[], total: number }>>(`${this.apiUrl}/public/search?q=${query}&page=${page}&limit=${limit}`);
  }

  makePublic(id: string): Observable<GenericResponse<Template>> {
    return this.http.put<GenericResponse<Template>>(`${this.apiUrl}/${id}/make-public`, {});
  }

  clone(id: string): Observable<GenericResponse<Template>> {
    return this.http.post<GenericResponse<Template>>(`${this.apiUrl}/${id}/clone`, {});
  }
}
